import * as angular from "angular";
import {IController} from "angular";
import {PlanningDraftLayer} from "../../models/planning-draft-layer.model";

export class PlanningProjectSettingsLayerTabComponent implements IController {

  layer: PlanningDraftLayer;
  isSelected: boolean;
  isEditing: boolean;
  isDragOver: boolean;
  isDragging: boolean;
  isRemovable: boolean;

  onSelect: Function;
  onStartRename: Function;
  onCommitRename: Function;
  onToggleDisabled: Function;
  onRemove: Function;
  onLayerDragStart: Function;
  onLayerDragOver: Function;
  onLayerDragLeave: Function;
  onLayerDrop: Function;
  onLayerDragEnd: Function;

  /* @ngInject */
  constructor(private $element, private $scope) {
  }

  $postLink() {
    this.$element.on('dragstart', (event) => {
      this.$scope.$applyAsync(() => this.onLayerDragStart({layer: this.layer, event: event}));
    });
    this.$element.on('dragover', (event) => {
      event.preventDefault();
      this.$scope.$applyAsync(() => this.onLayerDragOver({layer: this.layer, event: event}));
    });
    this.$element.on('dragleave', () => {
      this.$scope.$applyAsync(() => this.onLayerDragLeave({layer: this.layer}));
    });
    this.$element.on('drop', (event) => {
      event.preventDefault();
      this.$scope.$applyAsync(() => this.onLayerDrop({layer: this.layer, event: event}));
    });
    this.$element.on('dragend', () => {
      this.$scope.$applyAsync(() => this.onLayerDragEnd());
    });
  }

  $onDestroy() {
    this.$element.off('dragstart dragover dragleave drop dragend');
  }

  onSelectClick() {
    this.onSelect({layer: this.layer});
  }

  onDoubleClick(event: Event) {
    this.onStartRename({layer: this.layer, event: event});
  }

  onNameBlur() {
    this.onCommitRename({layer: this.layer, name: this.layer.name});
  }

  onNameKeydown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.onCommitRename({layer: this.layer, name: this.layer.name});
    }
  }

  onRemoveClick(event: Event) {
    this.onRemove({layer: this.layer, event: event});
  }

  onToggleDisabledChange(disabled: boolean, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.onToggleDisabled({layer: this.layer, disabled: disabled});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectSettingsLayerTab', {
    bindings: {
      layer: '<',
      isSelected: '<',
      isEditing: '<',
      isDragOver: '<',
      isDragging: '<',
      isRemovable: '<',
      onSelect: '&',
      onStartRename: '&',
      onCommitRename: '&',
      onToggleDisabled: '&',
      onRemove: '&',
      onLayerDragStart: '&',
      onLayerDragOver: '&',
      onLayerDragLeave: '&',
      onLayerDrop: '&',
      onLayerDragEnd: '&'
    },
    template: require('./planning-project-settings-layer-tab.html').default,
    controller: PlanningProjectSettingsLayerTabComponent
  });
